import { useCurrentUser } from '@/hooks/data/user';
import { AllInclusive } from '@mui/icons-material';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { Space } from 'antd';

export default function DownloadLimitWidget() {
   const { user, error, isLoading } = useCurrentUser();
   const downloadLimit = user?.downloadLimit;
   const downloadUsage = user?.downloadUsage;
   const downloadUsagePercentage =
      downloadUsage > downloadLimit ? 100 : Math.round((downloadUsage / downloadLimit) * 100);

   if (isLoading) {
      return <div>loading</div>;
   }

   // if downloadLimit >= 200 return unlimted as this consider unlimted downloads
   if (downloadLimit >= 200) {
      return (
         <>
            <Space size={8} direction="horizontal" wrap>
               <AllInclusive
                  sx={{
                     color: 'primary.main',
                     border: '1px solid',
                     borderColor: 'primary.main',
                     borderRadius: '50%',
                     padding: '2px',
                     fontSize: '20px',
                  }}
               />

               <Typography variant="body" color="text.secondary" fontSize={14} fontWeight={500}>
                  Unlimited downloads
               </Typography>
            </Space>
         </>
      );
   }

   if (!downloadLimit && error) {
      return <div>error</div>;
   }

   if (user) {
      return (
         <div>
            <Stack direction="row" spacing={4} alignItems="center">
               <Box position={'relative'} display={'inline-flex'}>
                  <CircularProgress
                     variant="determinate"
                     value={100}
                     sx={{
                        color: 'grey.300',
                        position: 'absolute',
                     }}
                     size={24}
                     thickness={8}
                  />
                  <CircularProgress
                     thickness={8}
                     sx={{
                        strokeLinecap: 'round',
                        '&.MuiCircularProgress-circle': {
                           strokeLinecap: 'round',
                        },
                     }}
                     value={downloadUsagePercentage}
                     variant="determinate"
                     size={24}
                     color={downloadUsagePercentage > 80 ? 'error' : 'primary'}
                  />
               </Box>

               <Stack direction="column" spacing={0}>
                  <Typography variant="body" color="text.secondary" fontSize={12} fontWeight={400}>
                     Download limit
                  </Typography>

                  <Typography variant="body" color="text.secondary" fontSize={14} fontWeight={500}>
                     {downloadUsage} / {downloadLimit} downloads
                  </Typography>
               </Stack>
            </Stack>
         </div>
      );
   }

   return <div></div>;
}
